(ns common.re-frame
  (:require [mate.re-frame :as mr]
            [re-frame.core :as rf]
            [re-frame.db :as rf-db]
            [re-frame.loggers :as rf-logger]
            [re-frame.registrar :as rf-reg]
            [re-frame.subs :as rf-subs]
            [re-frame.utils :as rf-utils])
  #?(:cljs
     (:require-macros [common.re-frame])))

;; Stripped down version of re-frame.subs/subscribe at
;; https://github.com/day8/re-frame/blob/v1.4.3/src/re_frame/subs.cljc#L73-L91
;; It does not cache the subscription (which is expected to be a one-off).
;; and does not display a warning which can be confusing for special cases.

;; If this is used outside a reactive context, it does not need to be disposed:
;; - derefing reactions outside a reactive context won't create deref watchers,
;; - the subscription not being in the re-frame cache, we don't need it to be removed from there.
(defn uncached-subscribe [query]
  (if-let [cached (rf-subs/cache-lookup query)]
    cached
    (let [query-id (rf-utils/first-in-vector query)
          handler-fn (rf-reg/get-handler rf-subs/kind query-id)]
      (if (nil? handler-fn)
        (rf-logger/console :error
                           (str "re-frame: no subscription handler registered for: "
                                query-id
                                ". Returning a nil subscription."))
        (handler-fn rf-db/app-db query)))))

;; Stripped down version of re-frame.subs/subscribe at
;; https://github.com/day8/re-frame/blob/v1.4.3/src/re_frame/subs.cljc#L73-L91
;; It does not display a warning which can be confusing for special cases.
(defn no-warning-subscribe [query]
  (if-let [cached (rf-subs/cache-lookup query)]
    cached
    (let [query-id (rf-utils/first-in-vector query)
          handler-fn (rf-reg/get-handler rf-subs/kind query-id)]
      (if (nil? handler-fn)
        (rf-logger/console :error
                           (str "re-frame: no subscription handler registered for: "
                                query-id
                                ". Returning a nil subscription."))
        (rf-subs/cache-and-return query [] (handler-fn rf-db/app-db query))))))

(defn with-rf-dispatch-calls-into-fx-map* [f]
  (let [dispatch-calls-as-fx-data (atom [])
        effects (with-redefs [rf/dispatch (fn [event-v]
                                            (swap! dispatch-calls-as-fx-data conj [:dispatch event-v])
                                            nil)]
                  (f))]
    (-> effects
        (mr/into-fx @dispatch-calls-as-fx-data))))

(defmacro with-rf-dispatch-calls-into-fx-map [& bodies]
  `(with-rf-dispatch-calls-into-fx-map* (fn [] ~@bodies)))
